import RnIcon from '@/components/icon/icon.vue';
import { fieldMixin } from '@/mixins';

export default {
	name: 'cs-field-multi-select',
	components: { RnIcon },
	mixins: [fieldMixin],
	props: {
		defaultChecked: {
			type: Boolean,
			default: false,
		},
		initialValues: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		const options = Array.isArray(this.options) ? this.options : [];
		const initialValues = Array.isArray(this.initialValues) ? this.initialValues.filter(Boolean) : [];
		let values = [];

		if (initialValues.length) {
			values = initialValues;
		} else if (this.defaultChecked) {
			values = options.map(option => option.value);
		}

		return {
			isOpen: false,
			values,
		};
	},
	computed: {
		selectedCount() {
			return this.values.length;
		},
		visibleSelectedCount() {
			return this.values.length > 9 ? '9+' : this.values.length;
		},
		selectedValueLabel() {
			const options = Array.isArray(this.options) ? this.options : [];

			return this.values
				.map(value => {
					const match = options.find(option => option.value === value);
					return (match && match.name) || value;
				})
				.filter(Boolean)
				.join(', ');
		},
	},
	watch: {
		value(newValues) {
			if (!Array.isArray(newValues)) {
				return;
			}

			this.values = newValues;
		},
		values(newValues) {
			this.$emit('update:value', newValues);
		},
	},
	methods: {
		setIsOpen(state) {
			this.isOpen = state;
		},
	},
};
